import { Student } from '../types';

export const testStudents: Student[] = [
  {
    id: 'student-a',
    name: '수강생 A',
    email: 'student-a@example.com',
    phoneNumber: '010-1111-1111',
    birthDate: '1990-01-01',
    gender: 'female',
    address: '경기도 동두천시',
    registrationDate: '2024-01-01',
    lastLoginDate: '2024-12-01',
    totalCourses: 0,
    completedCourses: 0,
    currentCourses: 0,
    courseHistory: []
  },
  {
    id: 'student-b',
    name: '수강생 B',
    email: 'student-b@example.com',
    phoneNumber: '010-2222-2222',
    birthDate: '1992-05-15',
    gender: 'male',
    address: '경기도 동두천시',
    registrationDate: '2024-01-15',
    lastLoginDate: '2024-12-01',
    totalCourses: 0,
    completedCourses: 0,
    currentCourses: 0,
    courseHistory: []
  },
  {
    id: 'student-c',
    name: '수강생 C',
    email: 'student-c@example.com',
    phoneNumber: '010-3333-3333',
    birthDate: '1988-12-30',
    gender: 'male',
    address: '경기도 동두천시',
    registrationDate: '2024-02-01',
    lastLoginDate: '2024-12-01',
    totalCourses: 0,
    completedCourses: 0,
    currentCourses: 0,
    courseHistory: []
  }
];